import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  styled,
  Switch,
  Tooltip,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { toast } from "react-toastify";
import {
  REACT_DEVICE_ADD_INSTRUCTION,
  REACT_VIEW_DEVICE,
} from "../../actions/EndPoints";
import { ReactComponent as Information } from "../../assets/DeviceIcon/Information.svg";
import { ReactComponent as CreateIcon } from "../../assets/USA_Images/CreateIcon.svg";
import DataTableLatest from "../../components/DataTable/DataTableLatest";
import MoreOption from "../../components/v4/MoreOption";
import {
  listOfDevice,
  rebootDevice,
} from "../../slices/Zlink Device Management/DeviceSlice";
import { ThemeContext } from "../../theme/ThemeContext";
import RefreshIcon from "../VisitingAccessLevels/RefreshIcon";
import DeleteDevice from "./DeleteDevice";
import FilterDevice from "./FilterDevice";

const MaterialUISwitch = styled(Switch)(({ theme }) => ({
  width: 54,
  height: 38,
  padding: 7,
  "& .MuiSwitch-switchBase": {
    margin: 11,
    padding: 0,
    transform: "translateX(5px)",
    backgroundColor: "#fff",
    "&.Mui-checked": {
      color: "#fff",
      transform: "translateX(15px)",
      "& .MuiSwitch-thumb:before": {
        backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
          "#226BAB"
        )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
      },
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: "#226BAB",
      },
    },
  },
  "& .MuiSwitch-thumb": {
    backgroundColor: "#f1f1f1",
    width: 15,
    height: 15,
    "&:before": {
      content: "''",
      position: "absolute",
      width: "100%",
      height: "100%",
      left: 0,
      top: 0,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
    },
  },

  "& .MuiSwitch-track": {
    opacity: 1,
    backgroundColor: "#fff",
    borderRadius: 30 / 2,
    border: "1px solid #cdcdcd",
  },
}));

const styleDialog = {
  "& .MuiDialog-paper": {
    padding: "5px 0px",
    position: "absolute",
    top: "5em",
    minWidth: "80vh",
    borderRadius: "14px",
  },
};
const defaultMenuData = [
  { label: "View device details", index: 0 },
  { label: "Person in this device", index: 2 },
  { label: "Sync data & time according to site", index: 3 },
  { label: "Clean device admin password", index: 4 },
  { label: "Reboot device", index: 5 },
  { label: "Delete device", index: 6 },
];

export const AccessDevice = () => {
  const [open, setOpen] = React.useState(false);
  const [clear, setClear] = React.useState(false);
  const [openInformation, setOpenInformation] = React.useState(false);
  const history = useHistory();
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [totalRecords, setTotalRecords] = useState(1);
  const [rows, setRows] = useState([]);
  const [newPage1, setNewPage] = useState(1);
  const [updateData, setUpdateData] = useState({});
  const [reload, setReload] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [deleteData, setDeleteData] = useState(false);
  const { darkMode, setDiaLogBoxBlur } = useContext(ThemeContext);
  const defaultFilter = {
    deviceAlias: "",
    deviceSn: "",
    deviceType: "",
  };
  const [filter, setFilter] = React.useState({
    ...defaultFilter,
  });
  const handleChange = (newPage, size) => {
    setNewPage(newPage);
    setPage(newPage);
    setRowsPerPage(size);
    loadData(newPage, size);
  };
  useEffect(() => {
    loadData(page, rowsPerPage);
  }, [filter]);

  useEffect(() => {
    if (reload === true) loadData(page, rowsPerPage);
  }, [reload]);

  const loadData = (page, rowsPerPage) => {
    const payload = {
      deviceAlias: filter.deviceAlias,
      deviceSn: filter.deviceSn,
      deviceType: filter.deviceType,
      pageNumber: page,
      pageSize: rowsPerPage,
    };
    dispatch(listOfDevice(payload))
      .unwrap()
      .then((data) => {
        if ((data.code = "DMSI0000" && data.data)) {
          setTotalRecords(data.data.totalCount);
          setRows(data.data.devices);
          setPage(data.data.currentPage);
          setTotalPages(data.data.totalPages);
          setReload(false);
          setOpen(false);
        } else {
          setRows([]);
          setTotalRecords(0);
          setPage(newPage1);
          setTotalPages(0);
        }
      })
      .catch((er) => { });
  };

  const columns = [
    {
      headerName: "",
      sortable: false,
      width: 5,
      renderCell: (params) => {
        return <div></div>;
      },
    },
    { field: "deviceName", headerName: t("VISACCDEV002"), flex: 1, width: 10 },
    { field: "sn", headerName: "SN", flex: 1, width: 10 },
    { field: "siteName", headerName: t("COMMON144"), flex: 1, width: 10 },
    { field: "zoneName", headerName: t("COMMON143"), flex: 1, width: 10 },
    { field: "deviceModel", headerName: t("Model"), flex: 1, width: 10 },
    {
      field: "status",
      headerName: t("commonsTextFieldLabelStatus"),
      flex: 1,
      width: 10,
      renderCell: (e) => (
        <span style={{ color: e.row.status === "1" ? "#36C96D" : "#f56a5f" }}>
          {e.row.status === "1" ? "Online" : "Offline"}
        </span>
      ),
    },

    {
      field: "Actions",
      headerName: t("ACTION"),
      type: "actions",
      flex: 1,
      minWidth: 180,
      width: 150,
      renderCell: (e) => (
        <Grid
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <MoreOption
            data={defaultMenuData}
            handleSelect={(option) => handleActions(option, e.row)}
          />
        </Grid>
      ),
    },
  ];
  const handleActions = (action, data) => {
    if (action === 0) {
      history.push({ pathname: REACT_VIEW_DEVICE, state: { ...data } });
    } else if (action === 5) {
      handleRebootDevice(data);
    } else if (action === 6) {
      setDeleteData(data);
      setDeleteOpen(true);
      setDiaLogBoxBlur(true);
    }
  };

  const handleRebootDevice = (data) => {
    const payload = {
      deviceId: data.id,
      operator: {
        operator: "reboot",
        deviceAlias: data?.deviceName,
        sn: data?.sn,
      },
    };
    dispatch(rebootDevice(payload))
      .unwrap()
      .then((data) => {
        if (data.code === "DMSI0000") {
          toast.success(data.msg);
        } else {
          toast.error(data.msg);
        }
      });
  };
  const resetFilter = () => {
    setClear(false);
    setPage(newPage1);
    setFilter({
      ...defaultFilter,
    });
  };
  const handleFilter = (data) => {
    setClear(true);
    setPage(1);
    setFilter({
      deviceAlias: data.deviceAlias,
      deviceSn: data.deviceSn,
      deviceType: data.deviceType,
    });
  };

  const clearSearch = () => {
    setFilter({
      ...defaultFilter,
    });
    loadData(page, rowsPerPage);
  };
  const handleClose = (data) => {
    setOpen(false);
    setDeleteOpen(false);
    setDiaLogBoxBlur(false);
  };

  const reloadlist = (value) => {
    setReload(true);
  };

  if (openInformation) {
    setDiaLogBoxBlur(true);
  }
  return (
    <>
      <Box
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "5px 10px",
        }}
      ></Box>
      <Box
        display={"flex"}
        width={"100%"}
        flexDirection={"row-reverse"}
        alignItems={"center"}
        marginTop={"17px"}
        gap="5px"
      >
        <Box item>
          {clear && (
            <Link
              href="#"
              underline="hover"
              className="line"
              style={{
                opacity: "1",
                color: "#E3393C",
                fontSize: "14px",
                underline: "hover",
                display: "inline",
              }}
              onClick={() => resetFilter()}
            >
              {t("CLEARFILTER")}
            </Link>
          )}
        </Box>
        <Tooltip title={t("Device")}>
          <Box
            item
            className={"addIcon"}
            onClick={() => history.push(REACT_DEVICE_ADD_INSTRUCTION)}
          >
            <CreateIcon />
          </Box>
        </Tooltip>
        <Tooltip title={t("COMMON002")}>
          <Box
            item
            className={darkMode ? "refreshIcondark" : "refreshIcon"}
            onClick={() => loadData(1, rowsPerPage)}
          >
            <RefreshIcon />
          </Box>
        </Tooltip>
        <Box item>
          <Tooltip title={t("Device Information")}>
            <Box
              item
              className={darkMode ? "infoIcondark" : "infoIcon"}
              onClick={() => setOpenInformation(!openInformation)}
            >
              <Information style={{ color: darkMode ? "#fff" : "#474a4e" }} />
            </Box>
          </Tooltip>
        </Box>

        <Box item>
          <FilterDevice
            onSubmit={(data) => {
              handleFilter(data);
            }}
          />
        </Box>
      </Box>
      <div style={{ height: 300, width: "100%", marginTop: "10px" }}>
        <DataTableLatest
          columns={columns}
          rows={rows}
          page={page}
          count={totalRecords}
          androidDeviceList={true}
          rowId={(row) => row.id}
          pageCount={totalPages}
          pageSize={rowsPerPage}
          handleChange={(newPage, size) => handleChange(newPage, size)}
        />
      </div>
      <Dialog
        sx={styleDialog}
        disableBackdropClick
        disableEscapeKeyDown
        BackdropProps={{
          style: {
            backdropFilter: "blur(5px)",
          },
        }}
        open={openInformation}
      >
        <DialogTitle
          id="form-dialog-title"
          variant="h4"
          style={{
            backgroundColor: darkMode ? "#0E2A41" : "#fff",
            position: "sticky",
            top: 0,
            zIndex: 10,
          }}
        >
          <IconButton
            aria-label="close"
            onClick={() => {
              setOpenInformation(!openInformation);
              setDiaLogBoxBlur(false);
            }}
            sx={{
              position: "absolute",
              right: 15,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
          {t("Device Center Info")}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {t("DEVICEINFOO")}
            {t("DEVICEINFOOO")}
          </DialogContentText>
          <DialogContentText
            id="alert-dialog-description"
            style={{ marginTop: "5px" }}
          >
            {t("DEVICEINFOO1")}
            {t("DEVICEINFOO2")}
          </DialogContentText>
        </DialogContent>
      </Dialog>
      {deleteOpen && (
        <DeleteDevice
          open={deleteOpen}
          onClose={handleClose}
          deleteData={deleteData}
          reloadlist={reloadlist}
        />
      )}
    </>
  );
};
